
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  * 
  * The source file is located at:
  *   /codebuild/output/src994476363/src/vl-app/pages/clinician/confirm.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import ConfirmAppointment from 'vl-common/src/components/BookAppointment/ConfirmAppointment';
import { useInitialisedStore } from '@hooks/useInitialisedStore';
import Header from '@components/Layouts/Header/Header';

const PageHead = dynamic(() => import('@components/Layouts/PageHead/PageHead'));

const ClinicianConfirm = () => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const { schedule } = router.query;
  const initialised = useInitialisedStore();

  if (!initialised) {
    return <p>{t('Initialising ...')}</p>;
  }

  return (
    <>
      <Header pageType="clinician" pageTitle="Confirm" />

      <section className="section-layout">
        <PageHead backUrl="/clinician/choose" backArrow backText="Back" />

        <main className="container" id="page-content">
          <ConfirmAppointment pageType="clinician" title="Appointment Confirmation" schedule={!!schedule} />
        </main>
      </section>
    </>
  );
};

export default ClinicianConfirm;
export const Route = createFileRoute('/clinician/confirm')({ component: ClinicianConfirm });
